import { render } from "./CreateOrderModification.vue?vue&type=template&id=8dc04bd4"
import script from "./CreateOrderModification.vue?vue&type=script&lang=js"
export * from "./CreateOrderModification.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__